function required(key: string): string {
	const value = import.meta.env[key] as string | undefined
	if (!value) {
		throw new Error(`Missing required environment variable: ${key}`)
	}
	return value
}

// Required
export const CONVEX_URL = required("VITE_CONVEX_URL")
export const PRIVY_APP_ID = required("VITE_PRIVY_APP_ID")
export const PRIVY_CLIENT_ID = required("VITE_PRIVY_CLIENT_ID")
export const SOLANA_RPC_URL = required("VITE_SOLANA_RPC_URL")
export const SENTRY_DSN = required("VITE_SENTRY_DSN")

// Optional
export const POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY as string | undefined
export const POSTHOG_HOST =
	(import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? "https://us.i.posthog.com"
